import React from "react";
import { toast } from "react-toastify";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";
import { useCreateSignatureLink } from "../hooks";

interface IProps {
  orderId: number;
  onCompleted: () => void;
}

export const SignatureLinkForm: React.FC<IProps> = ({ orderId, onCompleted }) => {
  const { form, submit, loading } = useCreateSignatureLink({
    defaultValues: { orderId, token: crypto.randomUUID() },
    onCompleted: () => {
      toast.success("Le lien de signature a été créé");
      onCompleted();
    },
  });

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Input
        label="Email destinataire"
        className="w-full"
        {...form.register("recipientEmail", { required: true })}
      />
      <Input
        label="Expire le"
        type="date"
        className="w-full"
        {...form.register("expiresAt", { required: true })}
      />
      <Button onClick={submit} loading={loading} disabled={loading}>
        Créer le lien
      </Button>
    </div>
  );
};
